import { search } from "lib/text";

import ShopItem from "state/school_money/entities/ShopItem";
import {
  getStudentByID,
  getBasketItemsOfType
} from "state/school_money/selectors";

export function getShopItemIDList(state) {
  return state.getIn(["school_money", "shopItems"]).keySeq().toList();
}

/**
 * @returns {boolean}
 */
export function doesShopItemExist(state, shopItemID) {
  return getShopItemIDList(state).includes(shopItemID);
}

export function getShopItemByID(state, shopItemID) {
  return state.getIn([ "school_money", "shopItems", shopItemID ]);
}

export function getShopItemSearchQuery(state) {
  return state.getIn(["school_money", "shopItemSearchQuery"]);
}

export function getFilteredShopItemIDList(state, studentID) {
  const schoolID = getStudentByID(state, studentID).get("schoolID");
  const searchQuery = getShopItemSearchQuery(state);
  return state.getIn([ "school_money", "shopItems" ])
    .filter(shopItem => shopItem.get("schoolID") === schoolID)
    .filter(shopItem => search(shopItem.get("name"), searchQuery))
    .filter(shopItem => shopItem.get("quantity") > 0)
    .sortBy(shopItem => shopItem.get("name"))
    .keySeq().toList();
}

export function getShopItemBasketItem(state, shopItemID, studentID) {
  const basketItems = getBasketItemsOfType(state, "shopItem");
  return basketItems.find(basketItem => {
    const payload = basketItem.get("payload").toObject();
    return payload.studentID === studentID && payload.shopItemID === shopItemID;
  });
}

export function getShopItemBasketQuantity(state, shopItemID, studentID) {
  const basketItem = getShopItemBasketItem(state, shopItemID, studentID);
  if (basketItem === undefined) {
    return 0;
  }
  return basketItem.getIn(["payload", "quantity"], 0);
}

export function getShopItemMaxBasketQuantity(state, shopItemID) {
  const shopItem = getShopItemByID(state, shopItemID);
  return Math.min(shopItem.quantity, ShopItem.MAX_BASKET_QUANTITY);
}

export function isShopItemSeen(state, shopItemID) {
  return state.getIn(["school_money", "seenShopItemIDs"]).includes(shopItemID);
}

/**
 * Get shop items that haven't yet been seen (for home page)
 * @returns {Immutable.List}
 */
export function getNewShopItems(state, count) {
  const shopItemIDList = getShopItemIDList(state);
  return shopItemIDList
    .filterNot(shopItemID => isShopItemSeen(state, shopItemID))
    .map(shopItemID => getShopItemByID(state, shopItemID))
    .filter(shopItem => shopItem.get("quantity") > 0)
    .take(count);
}

export function isShopReady(state) {
  return !state.getIn([ "school_money", "isShopLoading" ]);
}

export function getGoToShopItemID(state) {
  return state.getIn(["school_money", "goToShopItemID"]);
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/shop.js